module.exports = __webpack_public_path__ + "img/base_activites_bike_park.d6e1b60b.svg";